import { Controller } from 'stimulus';
import { slideUp } from 'dom-slider';

export default class SessionFormController extends Controller {
  connect() {
    if (this.element.classList.contains('ez-flash-message--auto-dismiss')) {
      setTimeout(() => {
        this.dismiss();
      }, 3000);
    }
  }

  dismiss() {
    this.element.slideUp();
  }
}
